import { Avatar } from '@mui/material';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../../theme';
import { ButtonStyled, MenuStyled } from '../../../theme/style';

interface ButtonDropdownStyledProps {
    menuopen?: boolean
}

export const ButtonDropdownStyled = styled(ButtonStyled)(({ menuopen }: ButtonDropdownStyledProps) => `
  && {
    font-weight: ${fontWeight.regular};
    padding: 10px;
    color: ${menuopen ? colors.grey300 : colors.default}!important;
    width: 146px;
    font-size: ${fontSize.sm};
    background-color: ${menuopen ? colors.lighten : colors.grey000};
    border: ${menuopen ? '1px solid' : '1px solid'};
    border-color: ${menuopen ? colors.default : 'transparent'};
    align-items: center;
    &.Mui-disabled {
        background-color: ${colors.grey700};
        color: ${colors.grey500}!important;
        cursor: not-allowed;
        & p {
          color: ${colors.grey500}!important;
        }
    }
    &:active {
            border: 1px solid ${colors.default};
        }
        &:hover {
            background: ${colors.grey600};
        }
    }
  }

`);

export const MenuDropdownStyled = styled(MenuStyled)`
  && {
      .MuiMenu-list {
        box-shadow: 0px 10px 60px rgba(33, 22, 69, 0.16);
        border-radius: 8px;
        background-color: ${colors.grey000};
        text-align: right;
        width: fit-content;
        min-width: 146px;
    }
    .MuiMenu-paper {
        border-radius: 8px;
        width: fit-content;
        min-width: 146px;
        max-width: fit-content;
    }
    width: fit-content;
    min-width: 146px;
    @media print {
        display: none;
    }
  }
`;

export const AvatarStyled = styled(Avatar)`
    && {
        width: 32px;
        height: 32px;
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.semiBold};
        background-color: ${colors.grey600};
        color: ${colors.grey100};
        font-family: ${fontFamilyPrimary}
    }
`;
